<div class="gradient-border-card mb-3">
    <div class="p-4">

        <!-- TITLE -->
        <h6 class="fw-bold headings-primary mb-3">Service Providers</h6>

        <!-- LIST -->
        <div class="d-flex flex-column gap-3">

        <!-- SERVICE ITEM -->
        <div
            v-for="(item, index) in providers"
            :key="index"
            class="service-provider-item rounded-3 shadow-sm p-3 d-flex justify-content-between align-items-center"
        >

            <!-- LEFT SECTION -->
            <div class="d-flex align-items-center gap-3">

            <!-- ICON -->
            <div class="provider-icon d-flex justify-content-center align-items-center rounded-3">
                <i :class="item.icon"></i>
            </div>

            <!-- NAME + CATEGORY -->
            <div>
                <div class="fw-semibold">{{ item.name }}</div>
                <div class="text-muted text-xxs">{{ item.category }}</div>
            </div>

            </div>

            <!-- PHONE NUMBER -->
            <div class="fw-semibold headings-primary text-xs text-end">
            {{ item.phone }}
            </div>

        </div>

        </div>

    </div>
</div>
